<template>
  <div class="type_search">
      <div class="type">
        <ul>
            <!-- <li>License ID</li>
            <li>项目名称</li>
            <li>申请工单号</li>
            <li>申请人</li>
            <li>最终客户</li> -->
            <li v-for="(item,index) in contentType" :key="index" :class='index==selected?"selected":""'><span @click="getType(item,index)" style="margin-right:16px;cursor: pointer;">{{item.text}}</span><span style="color:#E0E0E0">|</span></li>
        </ul>
      </div>
      <div class="search_input_box">
          <!-- <input v-model.trim="chooosedResult" type="text" ref="search_text" @input="handleChange" placeholder="请输入搜索内容"> -->
          <input v-model.trim="chooosedResult" type="text" ref="search_text" @input="toInput"  placeholder="请输入搜索内容"  @keydown="clcikEnterToSearch($event)" >
          <!-- <div class="icon-search search" @click="handleChange"></div> -->
      </div>
      <div class="scroll_box">
        <a-spin :spinning="spinning">
          <vuescroll ref="scrollDiv" :ops="ops" @load-start="handleLoadStart">
            <div class="search_content_box" @scroll="toScroll">
              <div class="search_result_list" @click="getResultInType(item,index)" v-for="(item,index) in searchResultList" :key="index"><a-tooltip :title="item" placement="topLeft">{{item}}</a-tooltip></div>
              <p class="empty_data" v-show="searchResultList.length == 0 "></p>
            </div>
          </vuescroll>
        </a-spin>
      </div>
  </div>
</template>

<script>
import { Select, Spin, Tooltip } from 'ant-design-vue'
import vuescroll from 'vuescroll'
import { debounce } from '@/util/utils.js'
import { createNamespacedHelpers } from 'vuex'
import '@/less/selectSearch/selectSearch.less'

const { mapActions,mapMutations,mapState } = createNamespacedHelpers('operation')

// License 类型（envType）本地枚举，选中「License类型」时不请求接口
const LICENSE_ENV_TYPE_LIST = [
  { label: '测试', value: '1' },
  { label: '生产', value: '2' },
  { label: 'POC', value: '3' },
  { label: '正式', value: '4' },
  { label: '续约', value: '5' },
  { label: '功能验证', value: '6' }
]

export default {
  data () {
    return {
      canPull: true,
      spinning: false,
      ops:{
        bar:{
          background: "#888888",
          disable: true
        },
        vuescroll: {
          mode: 'slide',
          pushLoad: {
            enable: true,
            auto: true,
            autoLoadDistance: 10,
            tips: {
              deactive: '下拉刷新',
              active: '释放刷新',
              start: '刷新中...',
              beforeDeactive: '刷新成功!'
            }
          }
        }
      },
      showResult:false,
      contentTypeConfig:[
        {
          value:"1",
          text:"License ID",
          fallbackKey:"licenseId"
        },
        {
          value:"2",
          text:"项目名称",
          fallbackKey:"projectName"
        },
        {
          value:"3",
          text:"License类型",
          fallbackKey:"envType"
        },
        {
          value:"4",
          text:"申请人",
          fallbackKey:"applicantName"
        },
        {
          value:"5",
          text:"最终客户",
          fallbackKey:"customerName"
        },
        {
          value:"6",
          text:"商机 ID",
          fallbackKey:"businessId"
        },
      ],
      choosedType:"1",// 默认无搜索类型,
      contentTypeText:"License ID",
      pageNo: 1,
	    pageSize: 20,
      clickKey:"licenseId",
      selected:0,
      searchResultList:[],
      chooosedResult:"",
      currentCombinedBlock:"",
      searchToken: 0
    }
  },
  created(){
    this.toScroll = debounce(this.handleScroll, 500)
    this.toInput = debounce(this.handleInput, 500)
    this.clickKey = this.contentType[0]?.key || "licenseId"
  },
  computed:{
    ...mapState(['isClickTypeFlag', 'metadata']),
    metaData () {
      return this.metadata || {}
    },
    metaDataFieldMap () {
      const map = {}
      const allMeta = [
        ...(this.metaData?.dimensions || []),
        ...(this.metaData?.metrics || [])
      ]
      allMeta.forEach((item) => {
        const key = typeof item === 'string'
          ? item
          : (item?.key || item?.field || item?.code || item?.column || item?.name || item?.id || '')
        const title = typeof item === 'string'
          ? item
          : (item?.title || item?.label || item?.nameCn || item?.name || '')
        if (key && title) {
          map[title] = key
          map[String(title).replace(/\s+/g, '')] = key
        }
      })
      return map
    },
    contentType () {
      return this.contentTypeConfig.map((item) => {
        const keyFromMeta = this.metaDataFieldMap[item.text] || this.metaDataFieldMap[item.text.replace(/\s+/g, '')]
        return {
          ...item,
          key: keyFromMeta || item.fallbackKey
        }
      })
    }
  },
  methods:{
    ...mapActions(['queryDataInType']),
    ...mapMutations(['alreadyClickType']),
    handleLoadStart (vm, refreshDom, done) {
      if (this.choosedType === '3') {
        setTimeout(() => { done() }, 100)
        return
      }
      this.pageNo += 1
      if (this.canPull) {
        this.search()
      }
      setTimeout(() => {
        done()
      }, 100)
    },
    handleScroll (e) {
      if (e.srcElement.scrollTop + e.srcElement.clientHeight === e.srcElement.scrollHeight) {
        this.$refs['scrollDiv'].triggerRefreshOrLoad('load')
      }
    },
    getType(item,index){
      if(item){
        this.alreadyClickType(true)
        //
        if(this.isClickTypeFlag === true){
          this.selected=index;
          this.choosedType=item.value;
          this.contentTypeText=item.text;
          this.clickKey = item.key
        }
        this.$emit("transferClickType", this.choosedType)
        this.$emit("transferClickKey",this.clickKey)
      }
    },
    // 根据输入框的字段 查询结果显示在下拉列表中
    // 通过 searchToken 解决竞态：每次搜索递增 token，响应返回后若 token 已过期则丢弃结果；输入清空时重置列表并使进行中的请求失效 - By AICode
    buildLicenseEnvTypeLabels (inputedValue) {
      const q = (inputedValue || '').trim()
      if (!q) {
        return LICENSE_ENV_TYPE_LIST.map((x) => x.label)
      }
      return LICENSE_ENV_TYPE_LIST
        .filter((x) => x.label.indexOf(q) !== -1 || x.value === q)
        .map((x) => x.label)
    },
    async search(){
      this.showResult=true;
      const key = this.clickKey
      let inputedValue = this.$refs.search_text.value.trim();
      if (this.choosedType === '3') {
        this.searchToken++
        this.spinning = false
        this.canPull = false
        this.searchResultList = this.buildLicenseEnvTypeLabels(inputedValue)
        return
      }
      let params = {
        field: key,
        searchText: inputedValue,
        pageNo: this.pageNo,
	      pageSize: this.pageSize
      }
      this.searchToken++
      if(!inputedValue){
        this.searchResultList = []
        this.spinning = false
        this.canPull = true
        return
      }
      if (this.pageNo === 1) {
        this.searchResultList = []
      }
      const currentToken = this.searchToken
      this.spinning = true
      const result = await this.queryDataInType(params)
      if (currentToken !== this.searchToken) return
      this.spinning = false
      let allSearchData = []
      if(result.pageNo*result.pageSize >= result.totalRecord){
        this.canPull = false
      }
      if (result && result.results && result.results.length) {
        result.results.forEach((item) => {
          allSearchData.push(item[key])
        })
      }
      this.searchResultList = this.searchResultList.concat(allSearchData)
    },
    handleInput(){
      if(typeof this.chooosedResult === 'string'){
        this.pageNo = 1
        this.searchResultList=[]
        this.canPull = true
        this.search()
      }
    },
    // 回车搜索
    clcikEnterToSearch(event){
      if(event.keyCode == 13){
        this.pageNo = 1
        this.searchResultList=[]
        this.canPull = true
        this.search();
      }
    },
    // 手动点击放大镜搜索
    handleChange(){
      let flag = false
      // if(this.isClickTypeFlag){
        if(this.chooosedResult){
          this.search();
          flag=true
        }
        else{

        }
      // }
      // else{
      //    this.$message.warning('请先选择类型，再进行检索');
      // }
    },
    getResultInType(item,index){
      var obj = {};
      if (this.clickKey === 'envType') {
        const row = LICENSE_ENV_TYPE_LIST.find((x) => x.label === item)
        obj.combindedBlock = this.contentTypeText + ':' + (row ? row.label : item)
        obj.paramsValue = row ? row.value : item
      } else {
        obj.combindedBlock = this.contentTypeText + ':' + item
        obj.paramsValue = item
      }
      this.currentCombinedBlock = obj.combindedBlock
      obj.params = this.clickKey
      this.$emit("transferCombinedContent", obj)
    }
  },
  watch:{
    selected (newValue, oldValue) {
      this.chooosedResult=""
      this.searchResultList=[]
      if (this.contentType[newValue] && this.contentType[newValue].value === '3') {
        this.canPull = false
        this.$nextTick(() => {
          if (!this.$refs.search_text) return
          this.search()
        })
      } else {
        this.canPull = true
      }
    }
  },
  components:{
      ASelect: Select,
      ASelectOption: Select.Option,
      ASpin: Spin,
      ATooltip: Tooltip,
      vuescroll
  }
}
</script>

<style>

</style>
